const {
  generateDependenciesToken,
  EMPTY_DEPENDENCIES_TOKEN,
} = require('@wix/cloud-user-code-dependencies-token-generator');
const { enrichLegacyUrl, enrichParastorageUrl } = require('./urlEnrichers');
const {
  generateCacheBuster,
  generateVeloBundlerCacheBuster,
} = require('@wix/cloud-user-code-cache-buster-generator');

const generateDependenciesTokenFromCodePackages = (codePackagesData) => {
  if (!codePackagesData || codePackagesData === []) {
    return EMPTY_DEPENDENCIES_TOKEN;
  }

  const codePackagesObject = codePackagesData.reduce((acc, codePackage) => {
    acc[codePackage.importName] = codePackage.gridAppId;
    return acc;
  }, {});

  return generateDependenciesToken(codePackagesObject);
};

const createUserCodeMapWithEnrichedUrls = ({
  userCodeMap,
  codePackagesData,
}) => {
  const dependenciesToken =
    generateDependenciesTokenFromCodePackages(codePackagesData);

  return userCodeMap.map((userCodeData) => {
    const isBundlerParastorageUrl = userCodeData.url.startsWith(
      'https://bundler-velo.parastorage.com',
    );

    const url = isBundlerParastorageUrl
      ? enrichParastorageUrl(
          userCodeData.url,
          generateVeloBundlerCacheBuster(),
          dependenciesToken,
        )
      : enrichLegacyUrl(userCodeData.url, {
          'dependencies-token': dependenciesToken,
          'cache-buster': generateCacheBuster(),
        });

    return {
      ...userCodeData,
      url,
    };
  });
};

module.exports = {
  createUserCodeMapWithEnrichedUrls,
  generateDependenciesTokenFromCodePackages,
};
